import { render, staticRenderFns } from "./HotelDetails.vue?vue&type=template&id=48a3d759&scoped=true&"
import script from "./HotelDetails.vue?vue&type=script&lang=js&"
export * from "./HotelDetails.vue?vue&type=script&lang=js&"
import style0 from "./HotelDetails.vue?vue&type=style&index=0&id=48a3d759&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3d759",
  null
  
)

export default component.exports